/**
 * boardThemes.js — Duelo chessboard color schemes.
 *
 * Each theme provides:
 *   lightSquare  — CSS color string for light squares
 *   darkSquare   — CSS color string for dark squares
 *   highlightFrom — CSS color for the "from" square of last move
 *   highlightTo   — CSS color for the "to" square of last move
 *   selectedSquare — CSS color for selected square
 *   legalDot      — CSS color for legal-move dots
 *   legalCapture  — CSS color ring for capture targets
 */

export const boardThemes = {
  /** Duelo signature — warm obsidian + aged gold (default) */
  duelo: {
    name: 'Duelo',
    lightSquare: '#c8b06a',
    darkSquare: '#3d3022',
    highlightFrom: 'rgba(212, 168, 32, 0.28)',
    highlightTo: 'rgba(212, 168, 32, 0.42)',
    selectedSquare: 'rgba(212, 168, 32, 0.55)',
    legalDot: 'rgba(212, 168, 32, 0.55)',
    legalCapture: 'rgba(212, 168, 32, 0.40)',
  },

  /** Classic tournament green */
  classic: {
    name: 'Classic',
    lightSquare: '#f0d9b5',
    darkSquare: '#b58863',
    highlightFrom: 'rgba(20, 85, 30, 0.35)',
    highlightTo: 'rgba(20, 85, 30, 0.50)',
    selectedSquare: 'rgba(20, 85, 30, 0.60)',
    legalDot: 'rgba(20, 85, 30, 0.55)',
    legalCapture: 'rgba(20, 85, 30, 0.40)',
  },

  /** Midnight blue — dark premium */
  midnight: {
    name: 'Midnight',
    lightSquare: '#8ca2c0',
    darkSquare: '#1e3a5f',
    highlightFrom: 'rgba(100, 180, 255, 0.28)',
    highlightTo: 'rgba(100, 180, 255, 0.44)',
    selectedSquare: 'rgba(100, 180, 255, 0.55)',
    legalDot: 'rgba(100, 180, 255, 0.55)',
    legalCapture: 'rgba(100, 180, 255, 0.40)',
  },

  /** Slate monochrome */
  slate: {
    name: 'Slate',
    lightSquare: '#c8c8c8',
    darkSquare: '#4a4a4a',
    highlightFrom: 'rgba(255, 255, 255, 0.20)',
    highlightTo: 'rgba(255, 255, 255, 0.32)',
    selectedSquare: 'rgba(255, 255, 255, 0.42)',
    legalDot: 'rgba(255, 255, 255, 0.50)',
    legalCapture: 'rgba(255, 255, 255, 0.35)',
  },
}

export const DEFAULT_BOARD_THEME = 'duelo'
